<template>
  <v-app>
    <v-toolbar app fixed clipped-left>
      <img src="@/assets/logo.png" data-retina="true" alt class="logo_normal">
    </v-toolbar>

    <v-navigation-drawer app fixed clipped dark class="blue lighten-3">
      <v-list>
        <v-list-tile :to="{ name: 'backend-users' }">
          <v-list-tile-action>
            <i class="pe-7s-users"></i>
          </v-list-tile-action>
          <v-list-tile-title>Users</v-list-tile-title>
        </v-list-tile>

        <v-list-tile :to="{ name: 'backend-trips' }">
          <v-list-tile-action>
            <i class="pe-7s-plane"></i>
          </v-list-tile-action>
          <v-list-tile-title>Trips</v-list-tile-title>
        </v-list-tile>

        <v-list-tile :to="{ name: 'backend-bookingrequests' }">
          <v-list-tile-action>
            <i class="pe-7s-users"></i>
          </v-list-tile-action>
          <v-list-tile-title>Booking requests</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-content>
      <v-container>
        <slot/>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Vue from 'vue'
import Vuetify from 'vuetify'

import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

export default {

}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Material+Icons');

i {
  font-size: 24px;
  font-weight: bold;
}
</style>
